var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('span',{domProps:{"textContent":_vm._s(_vm.value)}}),(_vm.display)?_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g({staticClass:"cursor-pointer",attrs:{"color":_vm.color}},on),[_vm._v(_vm._s(_vm.icon))])]}}],null,false,3466729662)},[_c('span',{domProps:{"textContent":_vm._s(_vm.tooltipText)}})]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }